import React from "react";
import GraphQLErrorList from "../common/GraphqlErrorList";
import Layout from "../../layout";

const Errors = ({ errors }) => (
  <Layout>
    <GraphQLErrorList errors={errors} />
  </Layout>
);

export default Errors;
